<template>
    <div class="programme">
        <!-- 政务转型解决方案 banner 部分 -->
        <div class="banner">
            <!-- 核心容器：限制宽度120rem并居中 -->
            <div class="banner-container" :style="{ backgroundImage: `url(${news.topPhotos})` }">
                <!-- 左侧标题区域 -->
                <div class="title-wrap">
                    <div class="title-row">
                        <h1 class="red-title">{{ news.redTitle }}</h1>
                        <h1 v-if="news.redTitle" style="color: #cccccc;font-size: 40px;font-weight: 11">|</h1>
                        <h1 class="main-title">{{ news.title }}</h1>
                    </div>
                    <h2 class="sub-title">{{ news.smallTitle }}</h2>
                  <p class="updateTime">发布时间：{{ news.updateTime }}</p>
                    <p class="synopsis">{{ news.synopsis }}</p>
                </div>

            </div>
        </div>

        <!-- 动态展示组件部分 -->
        <div class="wrap">
            <component
                style="margin-top: 50px;"
                v-for="(item, index) in news.zhWordDetailList"
                :key="index"
                :is="getComponentName(item.detailType)"
                :sourceData="item.detail"
                :title="item.title"
                :backUrl="item.backImg"
                :detailUrl="item.detailImg"
            />
        </div>
    </div>
</template>

<script>
import newService from "@/api/newService";
import sanjiaoxinghexing from "@/components/mian/detailViews/sanjiaoxinghexing.vue";
import fuwenben from "@/components/mian/detailViews/fuwenben.vue";
import hengtu from "@/components/mian/detailViews/hengtu.vue";
import sanhengtufuwenben from "@/components/mian/detailViews/sanhengtufuwenben.vue";
import yeqianfuwenben from "@/components/mian/detailViews/yeqianfuwenben.vue";
import zuoyiyouer from "@/components/mian/detailViews/zuoyiyouer.vue";
import {ArrowRight} from "@element-plus/icons-vue";

export default {
    name: "programmeOne",
    data() {
        return {
          news: {
                zhWordDetailList: [],
                redTitle: "",
                title: "",
                smallTitle: "",
                synopsis: "",
                updateTime: "",
                topPhotos: "" // 示例图片路径
            },
        };
    },
    mounted() {
        this.getNewsOne();
    },
    components: {
        ArrowRight,
        sanjiaoxinghexing,
        fuwenben,
        hengtu,
        sanhengtufuwenben,
        yeqianfuwenben,
        zuoyiyouer,
    },
    watch: {
      '$store.state.newsId': {
        handler() {
          this.getNewsOne()
        },
        immediate: true // 初始化时立即执行一次
      }
    },
    methods: {
        index() {
            this.$store.state.components = "home";
        },
        next() {
            this.$store.state.components = "news";
        },
      getNewsOne() {
            var id = this.$store.state.newsId;
            newService.getOneNews({id}).then((res) => {
                this.news = { ...this.news, ...res };
            });
        },
        getComponentName(detailType) {
            switch (detailType) {
                case "SAN_JIAO_HE_HEXING":
                    return "sanjiaoxinghexing";
                case "WORD_EDIT":
                    return "fuwenben";
                case "HENG_TU":
                    return "hengtu";
                case "SAN_HENG_TU":
                    return "sanhengtufuwenben";
                case "SPLIT_PAIN":
                    return "yeqianfuwenben";
                case "LEFT1_RIGHT2":
                    return "zuoyiyouer";
                default:
                    return "fuwenben";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.programme {
    width: 100%;

    .banner {
        /* 顶部背景图：全屏铺满 */
        background-image: url('@/assets/programme/programme1bg.png');
        background-size: cover;
        background-position: center;
        height: 30rem;
        position: relative;
        margin: 6.4rem auto 0;
        overflow: hidden;
        display: flex;
        align-items: center; /* 垂直居中内容 */
        justify-content: center; /* 水平居中容器 */
        padding: 0 20px; /* 小屏预留边距 */

        /* 核心容器：限制宽度120rem并居中 */

      .banner-container {
        width: 100%;
        max-width: 140rem; // 核心宽度限制
        height: 100%; // 撑满父容器高度
        display: flex;
        align-items: center;
        // 移除左右布局的gap和space-between
        background-size: cover; // 背景图覆盖容器
        background-position: center; // 背景图居中
        background-repeat: no-repeat; // 背景图不重复
        position: relative;
      }

        /* 左侧标题区域：占据剩余空间 */

        .title-wrap {
          margin-left: 10rem;
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 20px; /* 标题组内部间距 */

            /* 红字标题+主标题：同一行 */

            .title-row {
                display: flex;
                align-items: center;
                gap: 20px;
                flex-wrap: nowrap; /* 强制不换行 */
            }

            /* 红字标题样式 */

            .red-title {
                font-size: 48px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 700;
                color: #ed0200;
                margin: 0;
                line-height: 1.2;
            }

            /* 主标题样式 */

            .main-title {
                font-size: 48px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 700;
                color: #333;
                margin: 0;
                line-height: 1.2;
            }

            /* 副标题样式 */

            .sub-title {
                font-size: 25px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                color: #333;
                margin: 0;
                line-height: 1.2;
            }

            /* 简介样式 */

            .synopsis {
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #666;
                line-height: 1.8;
                margin: 0;
                max-width: 580px; /* 避免简介过宽 */
            }
          .updateTime {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #666;
            line-height: 1.8;
            margin-left: 2rem;
            max-width: 580px; /* 避免简介过宽 */
          }
        }

        /* 右侧图片样式 */

        //.banner-image {
        //    width: 580px; /* 图片固定宽度 */
        //    height: auto;
        //    object-fit: contain;
        //    flex-shrink: 0; /* 防止图片被压缩 */
        //}
    }

    /* 下方内容区域样式保持不变 */

    .wrap {
        display: block;
        overflow: hidden;
        margin: 0rem auto;
        padding: 0 20px;

        h3 {
            font-size: 2.8rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 2.8rem;
            margin-bottom: 3.2rem;
        }

        h4 {
            font-size: 1.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-bottom: 10.0rem;
            color: #444955;
            line-height: 4.0rem;
        }

        .programmeOne-box {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 6.0rem auto;

            div {
                width: 18.0rem;
                height: 26.0rem;
                margin: 0 0.5rem 4.0rem;
                background: white;
                box-shadow: 0rem 0.2rem 0.8rem 0rem rgba(0, 0, 0, 0.2);
                border-radius: 0.4rem;
                font-size: 1.8rem;
                font-family: PingFangSC-Medium, PingFang SC;
                padding: 2.0rem;
                font-weight: 500;
                color: #333333;
                line-height: 2;

                img {
                    width: 2.4rem;
                    height: 2.4rem;
                    margin-right: 0.5rem;
                }

                h5 {
                    margin: 0;
                    line-height: 2.0rem;
                }

                span {
                    display: flex;
                    margin-bottom: 2.0rem;
                }

                em {
                    font-style: normal;
                    font-size: 1.6rem;
                }
            }
        }
    }
}
</style>
